module.exports = __webpack_public_path__ + "img/status0.866183f9.svg";